import { Box, type BoxProps } from '@frameio/vapor';
import { IconLock } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/RestrictedFolderIcon';

export const RestrictedFolderIcon = (props: BoxProps) => (
  <Box
    {...props}
    alignItems="center"
    aria-label={TEXT.restricted}
    backgroundColor="base"
    borderRadius={4}
    display="flex"
    justifyContent="center"
    padding={2}
    role="img"
  >
    <IconLock aria-hidden={true} size={16} />
  </Box>
);

TEXT.DEFINE({
  restricted: 'Restricted',
});
